import template from './sites-main.html';
import App from '../../app';

const AMPLITUDE_EVENT_NAME = "Pageview: Sites";
class SiteMaineController {
  constructor() {}

  $onInit() {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }
}
export default {
  template,
  controller: SiteMaineController,
  controllerAs: 'vm',
};
